export const ITEM_MONIKER_NOT_FOUND = 'cantfind'
export const ITEM_MONIKER_TOO_MANY = 'toomany'
export const ITEM_MONIKER_TOO_SHORT = 'tooshort'

export const TOO_MANY_WARNING = 'Too many results, please be more specific. e.g. Unit 5/10 Seal St.'
export const TOO_SHORT_WARNING = 'Keep typing...'



// WEBPACK FOOTER //
// ./components/AutocompleteResult/constants.js